class InvoiceStatusType {
  Unknown() {
    return 0;
  }
  NotSuccessFull() {
    return 1;
  }
  SuccessFull() {
    return 2;
  }
  Canceled() {
    return 3;
  }
  Visited() {
    return 4;
  }
}
export default new InvoiceStatusType();